
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useAuth } from "@/components/auth/AuthProvider";

const MobileAuthSection = ({ onClose }: { onClose: () => void }) => {
  const { user } = useAuth();
  const userName = user?.user_metadata?.first_name || null;

  if (!user) {
    return (
      <div className="flex flex-col space-y-3">
        <Link 
          to="/auth/login" 
          className="flex items-center justify-center px-4 py-2 font-medium border border-grandpal-green rounded-md text-grandpal-green hover:bg-grandpal-green/10 transition-colors"
          onClick={onClose}
        >
          Sign In
        </Link>
        <Link 
          to="/auth/signup" 
          className="flex items-center justify-center px-4 py-2 font-medium rounded-md bg-grandpal-green text-white hover:bg-grandpal-green-dark transition-colors"
          onClick={onClose}
        >
          Sign up for Free
        </Link>
      </div>
    );
  }
  
  return (
    <div className="bg-grandpal-beige/50 p-4 rounded-lg">
      <h3 className="text-grandpal-green font-medium text-lg">
        {`Hi ${userName || 'there'}`}
      </h3>
      <div className="mt-3 space-y-2">
        <Link 
          to="/dashboard" 
          className="flex items-center text-gray-700 hover:text-grandpal-green transition-colors group"
          onClick={onClose}
        >
          <span className="flex-1">My Dashboard</span>
          <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
        </Link>
        <Link 
          to="/waitlist" 
          className="flex items-center text-gray-700 hover:text-grandpal-green transition-colors group"
          onClick={onClose}
        >
          <span className="flex-1">My Waitlist Applications</span>
          <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>
    </div>
  );
};

export default MobileAuthSection;
